import React, { memo, Fragment } from 'react';
import { LatexComponent } from 'components/HHQComponents'; // Điều chỉnh nếu cần
import { TestDetailQuizModel } from 'models/test-detail.model';
import './index.css';
interface PropTypes {
    question: TestDetailQuizModel;
    showTruth: boolean;
}
const TCHDienVaoNhieuChoTrongComponent: React.FC<PropTypes> = ({ question, showTruth }) => {
  return (
    <div>
      {(question.multiplePositionAnswer || []).map((positionAnswer, index) => {
        const childAnswers = positionAnswer.childQuestionAnswers || [];

        const correctAnswers = childAnswers.filter(a => a.isCorrect);
        const incorrectAnswers = childAnswers.filter(a => !a.isCorrect);

        const correctAnswerText = correctAnswers
          .filter(a => a.answer)
          .map(a => a.answer)
          .join(' hoặc ');

        const match = positionAnswer.answer?.match(/\[(\d+)\]/);
        let userValue = '--0_TNT_0--';

        if (match && question.userAnswer?.length) {
          const idx = parseInt(match[1], 10) - 1;
          userValue = question.userAnswer[idx];
        }

        // So sánh xem userValue có giống với bất kỳ correct answer không (loại bỏ khoảng trắng và lowercase)
        const isCorrect = correctAnswers
          .map(a => (a.answer || '').replace(/ /g, '').toLowerCase())
          .includes((userValue || '').replace(/ /g, '').toLowerCase());

        // Gợi ý
        let suggestion = correctAnswers
          .filter(a => a.comment)
          .map(a => a.comment)
          .join(' hoặc ');

        if (!isCorrect) {
          suggestion = incorrectAnswers
            .filter(a => a.comment)
            .map(a => a.comment)
            .join(' hoặc ');
        }

        return (
          <Fragment key={`answer${question.id}-${index}`}>
            <div className="dien_vao_nhieu_khoang_trong" />
            <div className="grid">
              <div className="col-12">
                Vị trí: <b>{positionAnswer.answer} </b> trả lời{' '}
                {isCorrect ? (
                  <span className="text-green-400 text-bold">Đúng</span>
                ) : (
                  <span className="text-red-400 text-bold">Sai</span>
                )}
              </div>

              {showTruth && !isCorrect && (
                <div className="col-12">
                  <LatexComponent>
                    <>
                      <span>
                        <i className="pi pi-check-square text-green-400 text-bold mr-2 font-size-14" />
                        Đáp án đúng:
                      </span>
                      <span
                        className="ml-1"
                        dangerouslySetInnerHTML={{ __html: correctAnswerText }}
                      />
                    </>
                  </LatexComponent>
                </div>
              )}

              {suggestion && (
                <div className="col-12">
                  <small>
                    <LatexComponent>
                      <>
                        - Gợi ý:{' '}
                        <b>
                          <span
                            className="ml-1"
                            dangerouslySetInnerHTML={{ __html: suggestion }}
                          />
                        </b>
                      </>
                    </LatexComponent>
                  </small>
                </div>
              )}
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};

export default memo(TCHDienVaoNhieuChoTrongComponent);
